module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"안녕! 용감한 쿠키들 사전예약","short_name":"사전예약","start_url":"/hellobravecookies/ko","lang":"ko","background_color":"#670f8a","theme_color":"#fff","icon":"src/images/favicon.png","display":"minimal-ui","localize":[{"start_url":"/hellobravecookies/zh-Hant","lang":"zh-Hant","name":"《Hello! 勇敢薑餅人》事前預約","short_name":"事前預約"}]},
    },{
      plugin: require('../node_modules/@devsisters/gatsby-plugin-pre-client/gatsby-browser.js'),
      options: {"plugins":[],"endpoint":"https://pre-api.devsisters.com/graphql"},
    },{
      plugin: require('../node_modules/@devsisters/gatsby-plugin-autotrack/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@devsisters/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-83665883-31"},
    },{
      plugin: require('../node_modules/@devsisters/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://41b17e9298d64ac397f84e283af0207b@sentry.io/1825779"},
    },{
      plugin: require('../node_modules/@devsisters/gatsby-plugin-i18n/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    }]
